import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsTreeAppend]'
})
export class TreeAppendDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
